import { Chart } from './Chart'
import type { ApexOptions } from 'apexcharts'

class DoubleLineChart extends Chart {
  options = {
    ...this.options,
    chart: {
      ...this.options.chart,
      type: 'line',
      height: 420,
      zoom: {
        enabled: false
      }
    },
    tooltip: {
      followCursor: true
    },
    colors: [],
    series: [],
    stroke: {},
    xaxis: {
      type: 'datetime',
      axisTicks: {
        show: false
      },
      tooltip: {
        enabled: false
      },
      labels: {
        format: 'dd MMM'
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: [],
          fontSize: '12px',
          cssClass: 'opacity-40'
        },
        formatter: function (value) {
          return value.toString()
        },
        offsetX: -5
      }
    },
    grid: {
      borderColor: '#E8E8E8'
    },
    legend: {
      markers: {
        width: 0
      },
      onItemClick: {
        toggleDataSeries: false
      },
      formatter: function (seriesName, opts) {
        const color = opts.w.config.colors[opts.seriesIndex]
        const type = opts.w.config.stroke.dashArray[opts.seriesIndex]
        const marker = type === 0 ? 'solid' : 'dashed'
        const css = `style="border-top: 2px ${marker} ${color};"`
        return `
        <div class="flex items-center h-10 -mr-2 mt-5 overflow-hidden">
          <span ${css} class="w-5 h-0 text-transparent">${seriesName}</span>
          <span class="mx-3">${seriesName}</span>
        </div>`
      }
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6
      }
    }
  } as ApexOptions

  setSeries(series: Array<{ name: string; data: [] }>): void {
    this.options.series = series
  }

  setColor(color: string[]): void {
    this.options.colors = color
  }

  setStroke(stroke: ApexStroke): void {
    this.options.stroke = stroke
  }

  setCategories(categories: string[]): void {
    this.options = {
      ...this.options,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: categories
        }
      }
    }
  }
}

export { DoubleLineChart }
